export default function ({ ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="64" height="99" viewBox="0 0 64 99" fill="none">
            <path
                d="M20.3768 57.9407H3.20352C0.961393 57.9407 -0.585269 55.4004 0.212595 53.0305L17.2771 2.33255C17.5079 1.64665 17.9175 1.05632 18.4514 0.639769C18.9853 0.223221 19.6185 0.000112018 20.2669 0H49.0626C51.3346 0 52.8834 2.6054 52.0258 4.98745L42.0898 32.5917H60.7948C63.5457 32.5917 65.0135 36.262 63.1991 38.6017L17.3389 97.7485C15.1096 100.624 10.9763 98.1324 11.8414 94.4344L20.3768 57.9407Z"
                fill="#FFECCF"
            />
        </svg>
    );
}
